import { render } from "./Customer_add.vue?vue&type=template&id=113fcb24"
import script from "./Customer_add.vue?vue&type=script&lang=js"
export * from "./Customer_add.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__